(ns frontend.view.nev.kyc.process.split-of-investment-portfolio-editor
  (:require [basic-components.inputs.footprint :refer [viewer editor]]
            [common.localization :as loc]
            [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]
            [frontend.utils :as fu]))

(defn view [{:keys [lang-kw question-attribute question-meta kyc-process answers-atom read-only? save!]}]
  (let [answers @answers-atom
        investment-split (get answers question-attribute)
        total-percentage-num (->> investment-split
                                  (vals)
                                  (apply +))
        total-percentage-str (fu/format-percentage total-percentage-num)
        validation-error (when (fn? (:validation-fn question-meta))
                           ((:validation-fn question-meta) {:answers answers
                                                            :kyc-process kyc-process}))]
    [:table.zap-table.zap-table--striped.zap-table--has-footer.zap-table--width-auto
     [:thead.zap-table__headline
      [:tr.zap-table__row
       [:th.zap-table__headline (loc/tr :portfolio-investment-category nil lang-kw)]
       [:th.zap-table__headline.text-right (loc/tr :percentage nil lang-kw)]]]
     [:tbody
      (->> kyc-options/split-of-investments-options
           (map (fn [opt]
                  (let [investment (:key opt)
                        value (get investment-split investment)]
                    [:tr.zap-table__row
                     {:key (str "investment-split-" (name investment))}
                     [:td.zap-table__cell
                      [:span
                       (-> opt :translations (get lang-kw))]]
                     [:td.zap-table__cell.text-right
                      (if read-only?
                        (str (fu/format-with-separators (* 100 (or value 0)) 2 false 2) "%")
                        [editor {:editor/type          :editor.type/percentage
                                 :value                (or value 0)
                                 :attribute            investment
                                 :field/not-clearable? true
                                 :on-save!             (fn [_attribute new-value]
                                                         (swap! answers-atom assoc :kyc-legal-entity/split-of-investment-portfolio
                                                                (assoc investment-split
                                                                       investment new-value))
                                                         (deref answers-atom)
                                                         (save!))
                                 :on-blur!             (fn [_e new-value clear-cb!]
                                                         (swap! answers-atom assoc :kyc-legal-entity/split-of-investment-portfolio
                                                                (assoc investment-split
                                                                       investment new-value))
                                                         (deref answers-atom)
                                                         (clear-cb!)
                                                         (save!))}])]])))
           (doall))]
     [:tfoot
      [:tr.zap-table__row
       [:td.zap-table__footer-cell.text-right.px-2
        {:col-span "2"}
        [:span.summary-cell.pr-1
         total-percentage-str]
        (when (and validation-error
                   (not read-only?))
          [:p
           {:class "text-sm m-0 text-danger-regular break-words"}
           (loc/tr validation-error nil lang-kw)])]]]]))

